import utils from 'lib/utils';

const SessionStorageService = function () {
  if (SessionStorageService.prototype._singleton) {
    return SessionStorageService.prototype._singleton;
  }

  SessionStorageService.prototype._singleton = this;

  this.getItem = function (key) {
    return utils.tryParseJson(sessionStorage.getItem(key));
  };

  this.getByDotString = function (dotString) {
    return utils.getByDotString(dotString, this.getItem);
  };

  this.setItem = function (key, item) {
    if (key === undefined) {
      throw new Error('Cannot store an item in session with an undefined key.');
    }
    if (typeof item === 'object' || Array.isArray(item)) {
      sessionStorage.setItem(key, JSON.stringify(item));
    } else {
      sessionStorage.setItem(key, item);
    }
  };

  this.removeItem = function (key) {
    sessionStorage.removeItem(key);
  };

  /* Returns key/value pair object that maps to sessionStorage */
  this.getAll = function () {
    return Object.keys(sessionStorage).reduce(function (result, key) {
      if (key !== undefined) {
        result[key] = utils.tryParseJson(sessionStorage.getItem(key));
        return result;
      }
    }, {});
  };

  this.clear = function () {
    sessionStorage.clear();
  };
};

export default new SessionStorageService();
